module.exports = __webpack_public_path__ + "static/media/utente.94305b59.svg";